import React from 'react'
import {
    Box,
    Flex,
    useBreakpointValue,
    useMultiStyleConfig,
    Text,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import RefinementsTab from './refinements-tab'
import SortByButton from './sort-by-button'
import FiltersButton from './filters-button'
import {useIntl} from 'react-intl'
import PropTypes from 'prop-types'

const FiltersSection = ({
    productSearchResult,
    toggleFilter,
    handleResetFilters,
    onOpen,
    sortUrls,
    activeFiltersCount,
    selectedSortingOptionLabel,
}) => {
    const isMobile = useBreakpointValue({base: true, md: false})
    const styles = useMultiStyleConfig('ProductList')
    const intl = useIntl()
    const productTotalMessage = intl
        .formatMessage({id: 'account.heading.products', defaultMessage: 'Products'})
        .toUpperCase()
    return isMobile ? (
        <>
            <Box {...styles.refinementsTabContainer} display="flex" flexDir="column" w="100%">
                <Flex w="100%" justifyContent="space-between" alignItems="center">
                    <Flex width="auto" textAlign="center">
                        <Text
                            textStyle="body-xxsmall"
                            fontWeight="semibold"
                            color="foreground.neutral.subtle"
                        >
                            {productSearchResult?.total} {productTotalMessage}
                        </Text>
                    </Flex>
                    <Flex gap="xxxsmall-1.base" flexShrink={0} alignItems="center">
                        <FiltersButton
                            buttonClick={onOpen}
                            activeFiltersCount={activeFiltersCount}
                        />
                    </Flex>
                </Flex>
                <Flex
                    flex="1"
                    minW={0}
                    overflowX="auto"
                    overflowY="hidden"
                    whiteSpace="nowrap"
                    alignItems="center"
                >
                    <RefinementsTab
                        filters={productSearchResult?.refinements}
                        toggleFilter={toggleFilter}
                        handleReset={handleResetFilters}
                        selectedFilterValues={productSearchResult?.selectedRefinements}
                    />
                </Flex>
            </Box>
        </>
    ) : (
        <>
            <Box
                {...styles.refinementsTabContainer}
                w="100%"
                display="flex"
                alignItems="center"
                justifyContent="space-between"
            >
                <Flex
                    flex="1"
                    minW={0}
                    overflowX="auto"
                    overflowY="hidden"
                    whiteSpace="nowrap"
                    alignItems="center"
                >
                    <RefinementsTab
                        filters={productSearchResult?.refinements}
                        toggleFilter={toggleFilter}
                        handleReset={handleResetFilters}
                        selectedFilterValues={productSearchResult?.selectedRefinements}
                    />
                </Flex>
                <Flex gap="xxxsmall-1.base" flexShrink={0} alignItems="center">
                    {!isMobile && (
                        <SortByButton
                            key="sortby"
                            selectedSortingOptionLabel={selectedSortingOptionLabel}
                            sortUrls={sortUrls}
                            productSearchResult={productSearchResult}
                        />
                    )}
                    <FiltersButton buttonClick={onOpen} activeFiltersCount={activeFiltersCount} />
                </Flex>
            </Box>
        </>
    )
}

FiltersSection.propTypes = {
    productSearchResult: PropTypes.shape({
        total: PropTypes.number,
        refinements: PropTypes.array,
        selectedRefinements: PropTypes.object,
        sortingOptions: PropTypes.array,
    }),
    toggleFilter: PropTypes.func,
    handleResetFilters: PropTypes.func,
    onOpen: PropTypes.func,
    sortUrls: PropTypes.arrayOf(PropTypes.string),
    activeFiltersCount: PropTypes.number,
    selectedSortingOptionLabel: PropTypes.shape({
        label: PropTypes.string,
    }),
}

export default FiltersSection
